import React from 'react'

function Support() {
  return (
      <div className='w-full h-[90vh] flex flex-col items-center justify-center pb-20 my-auto gap-5'>
          <a href='http://telegram.org'
              className='bg-slate-900 text-base w-56 h-16 -tracking-wide border-2 border-blue-600 rounded-md flex 
                items-center justify-between px-8 gap-2 py-2 hover:border-purple-900 hover:scale-95 hover:px-6 duration-300'>
              <img className='w-10' src="https://seeklogo.com/images/T/telegram-logo-6E3A371CF2-seeklogo.com.png" alt="GoogleLogo" />
              <span className="text-lg font-semibold font-bodyFont tracking-widest text-cyan-300">&nbsp; Telegram </span>
          </a>
          <a href='https://discord.com/'
              className='bg-slate-900 text-base w-56 h-16 -tracking-wide border-2 border-blue-600 rounded-md flex 
                items-center justify-between px-8 gap-2 py-2 hover:border-purple-900 hover:scale-95 hover:px-6 duration-300'>
              <img className='w-10' src="https://cdn.logojoy.com/wp-content/uploads/20210422095037/discord-mascot.png" alt="GoogleLogo" />
              <span className="text-lg font-semibold font-bodyFont tracking-widest text-violet-300"> Discord &nbsp; </span>
          </a>
          <a href='https://twitter.com'
              className='bg-slate-900 text-base w-56 h-16 -tracking-wide border-2 border-blue-600 rounded-md flex 
                items-center justify-between px-8 gap-2 py-2 hover:border-purple-900 hover:scale-95 hover:px-6 duration-300'>
              <img className='w-10' src="https://cdn4.iconfinder.com/data/icons/social-media-icons-the-circle-set/48/twitter_circle-512.png" alt="GoogleLogo" />
              <span className="text-lg font-semibold font-bodyFont tracking-widest text-cyan-500"> Twitter &nbsp; </span>
          </a>
    </div>
  )
}

export default Support